@import '../../../../../constants/spacing.module.less';

.modal-body {
  padding: @space-24;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
}
